import { API_USER_DETAIL } from './models';

export type UserMapEntry = {
  userID: string;
  firstName?: string;
  lastName?: string;
};

export const USERS_MAP_SOURCE = `${API_USER_DETAIL.GET_ALL_DYNAMIC}?Select=userID,firstName,lastName&Filter=isActive==true`;

export function getUserFullName(user?: UserMapEntry | null): string {
  if (!user) {
    return '';
  }

  return [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
}

export function getUserInitials(user?: UserMapEntry | null): string {
  if (!user) {
    return '';
  }

  const first = user.firstName?.[0] ?? '';
  const last = user.lastName?.[0] ?? '';
  return `${first}${last}`.toUpperCase();
}
